export default __webpack_public_path__ + "static/youngChild-adfff5ed307c4ae54d08ba532d880676.svg";